import { NAV_MENUS } from "../../data/navigation";
import { useTranslation } from "../../hooks/useTranslation";

function XIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  );
}

export function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="border-t border-border bg-bg-surface">
      <div className="section-container py-16">
        {/* Main grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          {NAV_MENUS.map((menu) => (
            <div key={menu.label}>
              <h3 className="text-sm font-semibold text-text-primary mb-4">
                {menu.label}
              </h3>
              <ul className="space-y-2.5">
                {menu.items.map((item) => (
                  <li key={item.label}>
                    <a
                      href={item.href}
                      target={item.external ? "_blank" : undefined}
                      rel={item.external ? "noopener noreferrer" : undefined}
                      className="text-sm text-text-muted hover:text-primary-light transition-colors"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-8 border-t border-border">
          <div className="flex items-center gap-4">
            {/* Social links */}
            <a
              href="https://x.com/kubercoin"
              target="_blank"
              rel="noopener noreferrer"
              className="text-text-muted hover:text-text-primary transition-colors"
              aria-label="X (Twitter)"
            >
              <XIcon />
            </a>
          </div>

          <p className="text-sm text-text-muted">
            {t("footer.copyright")} {t("footer.license")}
          </p>

          <div className="flex gap-4 text-sm text-text-muted">
            <a
              href="https://kuber-coin.com"
              className="hover:text-text-secondary transition-colors"
            >
              kuber-coin.com
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
